/* eslint-disable object-curly-newline */
/* eslint-disable max-len */
G.OMTsettings = {
  /* configuration for Delta DNA, comment out block or remove to disable */
  DDNA: {
    collect: 'https://collect15042cndyr.deltadna.net/collect/api/',
    engage: 'https://engage15042cndyr.deltadna.net/',
    env: G.BuildEnvironment.production ? '45023937062490170730303425015584' : '45023927385646746900256410615584',
    queueInterval: 10000,
    ftuxVersion: 1, // this should be a integer
  },

  /* configuration for tournaments */
  tournaments: {
    levelLoop: ['tournament_2281', 'tournament_2289', 'tournament_2290', 'tournament_2286', 'tournament_2287', 'tournament_2288'],
    rotationOriginTimestamp: 1603065600000, // unix timestamp (1603065600000, is Monday 00:00:00, October 19th, 2020)
    rotationIntervalHrs: 24 * 7, // total hours for level rotation including the cooldown
    cooldownDurationHrs: 24 * 2, // hours at beginging of rotation
    worldMapIcon: {
      activeLabelOffset: { x: 0, y: 7 },
    },
    promotionPosOffset: {
      gingy: {
        y: 27,
      },
      tournamentText: {
        y: 13,
      },
    },
  },

  /* configuration for cross promotions */
  crossPromo: {
    promoId: 'candy-match-3',
    showIcon: true,
    worldMapIcon: {
      width: 127,
      height: 127,
    },
  },

  shoutouts: {
    amountTier0: 3,
    amountTier1: 2,
  },

  adFallback_AskFriend: {
    title: {
      style: { style: 'font-white', fontSize: 40 },
      offsetY: 10,
    },
    graphics: {
      evenColourBg: 0xd1f8fe,
      oddColourBg: 0xe5f8fb,
    },
  },

  requestHelp: {
    positionals: {
      useTwoPiecePopup: false,
      threePieceOffsetMid: 1,
      maskRadius: 40,
      listOffsetX: 0,
      scrollbarOffsetHeight: 0,
      friendBg1Color: 0xd1f8fe,
      friendBg2Color: 0xe5f8fb,
      friendBg3Color: 0x008aca,
      titleText: '#0089D4',
    },
  },

  requestMoveHelp: {
    // the index on this array will be the amount of times the current level has been retried - 1
    // if the player has retried the levels more times than there are percentages,
    // we pick the last percentage in the array.
    probabilities: [
      10,
      20,
      30,
      40,
    ],
  },

  friendshipChest: {
    assets: {
      storyChests: [
        { asset: 'storyFriendshipChest1', background: 'friendshipPolaroidBg' },
        { asset: 'storyFriendshipChest2', background: 'friendshipPolaroidBg' },
        { asset: 'storyFriendshipChest3', background: 'friendshipPolaroidBg' },
        { asset: 'storyFriendshipChest4', background: 'friendshipPolaroidBg' },
        { asset: 'storyFriendshipChest5', background: 'friendshipPolaroidBg' },
        { asset: 'storyFriendshipChest6', background: 'friendshipPolaroidBg' },
        { asset: 'storyFriendshipChest7', background: 'friendshipPolaroidBg' },
      ],
    },
    layoutData: {
      polaroidImageOffsetY: -55,
      messageHardBackground: 0x008aca,
      cardBackground: 0xFFF6FB,
      messageJoined: {
        fontSize: '150px',
        lineSpacing: -30,
        width: 370,
        height: 200,
      },
      bannerMask: {
        x: -311.37,
        y: -9.599999999999994,
        width: 622.74,
        height: 120,
      },
      bannerText: {
        yOffset: -10,
        fontSize: 86,
        offsetDivision: 4,
      },
    },
    maxCards: 50,
    width: 150,
  },

  FTUXSettings: {
    runLevelsUpTo: 10,
    gingyPosOffset: {
      y: 8,
    },
  },

  mapChest: {
    startLevel: 10,
    reoccuringLevel: 10,
    formulaChangePoint: 100,
    mapTileSizeInLevels: 14,
    appearanceNodes: [
      [ // level 1 ~ 4
        { x: 97, y: -342 },
        { x: -283, y: -499 },
        { x: -272, y: -529 },
        { x: -227, y: -608 },
        { x: 36, y: -625 },
      ],
      [ // 5 ~ 9
        { x: 224, y: -707 },
        { x: 149, y: -868 },
        { x: 276, y: -890 },
        { x: -11, y: -928 },
        { x: -264, y: -912 },
        { x: -124, y: -1076 },
      ],
      [ // 10 ~ 14
        { x: 114, y: -1346 },
        { x: 31, y: -1537 },
        { x: -166, y: -1589 },
        { x: 275, y: -1690 },
      ],
    ],
  },

  // Config for the special shop deal. Similar to eventPostcard but doesn't come with a lot of extra stuff
  specialShopDeal: {
    firstTimePackId: 'summer2020First',
    regularPackId: 'summer2020',
    valueTagMultiplier: 1,
    valueTagColours: 0xFF2EC2,
    coinBarTint: 0xff4200,
    mapIcon: {
      asset: 'summerSaleMapIcon',
      width: 150,
      height: 150,
    },
    saleBannerText: {
      offsetY: 0,
    },
  },

  postcardEvent: {
    title: {
      imageOffset: {
        x: -25,
        y: 0,
      },
      textOffset: {
        x: 0,
        y: 18,
      },
    },
  },

  tokenEvent: {
    gameBackgroundAsset: 'background_1',
    levelList: [109, 117, 113, 108, 102, 131, 133,
      135, 132, 140, 128, 124, 139, 143, 155, 177,
      178, 164, 190, 195, 200, 187, 194, 186, 211,
      213, 215, 230, 232, 225, 234, 228, 239, 263,
      290, 313, 332, 357, 358, 346, 384, 420, 407,
      432, 434, 426, 450, 449, 458, 442, 469, 462,
      490, 488, 499, 510, 509, 519, 526, 547, 548,
      567, 568, 564, 579, 593, 609, 619, 640, 667,
      710, 720, 707, 714, 706, 716, 721, 729, 734,
      722, 757, 743, 747, 756, 763, 772, 762, 813,
      820, 819, 821, 831, 833, 840, 855, 844, 874,
      898, 885, 886], // Populate in game repo
    popupOfferLayout: {
      showTargetOffer: false,
    },
    windowHeader: {
      text: {
        x: 15,
        y: -275,
        width: 240,
      },
    },
    mapIcon: {
      layout: {
        bg: {
          x: 0,
          y: 0,
        },
        token: {
          size: 90,
          x: 0,
          y: 20,
        },
        timerBanner: {
          x: 0,
          y: 39,
        },
        timerText: {
          x: 12,
          y: 41,
        },
      },
    },
  },

  treasureHuntSuper: {
    worldMapIcon: { // World map icon stuff
      timerText: { // Timer text adjustment
        y: 48,
      },
      timerPos: {
        y: 47,
      },
      animation: [ // Animation works on COOK!
        /* eslint-disable object-curly-newline */
        { asset: 'treasure_hunt_active_layer1', x: 0, y: -6, scaleTween: { x: 1.08 }, time: 6000, scale: 1, delay: 250 },
        { asset: 'treasure_hunt_active_layer2', x: 0, y: -6, tween: { y: -15, angle: 10 }, time: 6000, scale: 1, delay: 250 },
        /* eslint-enable object-curly-newline */
      ],
    },
    leaderboardConfig: {
      header: {
        bg: { asset: 'treasureHunt_banner_extra' },
        subTitle: {
          baseStyle: 'treasureHunt-leaderboardTitle',
        },
      },
      panel: {
        userView: {
          usernameField: {
            fontStylePlayer: {
              fill: 'white',
            },
          },
        },
      },
    },
    levels: {
      useList: true,
      levelList: [109, 117, 113, 108, 102, 131, 133,
        135, 132, 140, 128, 124, 139, 143, 155, 177,
        178, 164, 190, 195, 200, 187, 194, 186, 211,
        213, 215, 230, 232, 225, 234, 228, 239, 263,
        290, 313, 332, 357, 358, 346, 384, 420, 407,
        432, 434, 426, 450, 449, 458, 442, 469, 462,
        490, 488, 499, 510, 509, 519, 526, 547, 548,
        567, 568, 564, 579, 593, 609, 619, 640, 667,
        710, 720, 707, 714, 706, 716, 721, 729, 734,
        722, 757, 743, 747, 756, 763, 772, 762, 813,
        820, 819, 821, 831, 833, 840, 855, 844, 874,
        898, 885, 886],
        startingLevel: 383,
    },
    gameBoard: {
      counter: {
        textOffset: { x: 0, y: 1 },
        tokenOffset: {x: 10, y: 0 },
        doublingOfset: { x: -10, y: 0 },
      },
    },
    eventReminder: { // Settings for a window that shows a reminder to play!
      bannerData: {
        badge: { // Relative to .asset above
          size: 100,
        },
      },
    },
  },

  unlimitedLivesMinCap: 2880, // The maximum amount of minutes you can get when you get get unlimited lives

  // ===================================================================
  global: {
    gameName: 'Candy Match 3',
    defaultFont: 'Lobster',
    defaultFontStyle: 'font-darkBlue',
    leaderboardName: 'completedLevels',
    gameTracking: {
      active: true,
    },
    window: {
      title: {
        textStyle: 'globalTitleStyle',
      },
      mediumTitle: {
        textStyle: 'globalMedTitleStyle',
      },
      smallTitle: {
        textStyle: 'globalSmTitleStyle',
      },
    },
  },

  elements: {
    windowNineSlice: {
      banner: 'popup_generic_banner', // The banner asset to be used
      slice: { // The 9 slice of the popup
        top: 100,
        left: 73,
        right: 73,
        bottom: 59,
      },
      whiteSpace: { // The whitespace in the popup
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      },
      inner: { // The px to the inner look-good dimensions of the popup
        top: 90,
        left: 73,
        right: 73,
        bottom: 59,
      },
    },
    gingy: { // Fluffy
      backEyes: {
        x: 2,
        y: -20,
      },
      eyes: {
        x: 3,
        y: -23,
      },
      eyelids: {
        x: 3,
        y: -23,
      },
      mouth: {
        x: 5,
        y: 12,
      },
    },
    ginger: { // Max
      backEyes: {
        x: 2,
        y: -20,
      },
      eyes: {
        x: 3,
        y: -21,
      },
      eyelids: {
        x: 2,
        y: -22,
      },
      mouth: {
        x: 1,
        y: 23,
      },
    },
    chip: { // Buttons
      backEyes: {
        x: -2,
        y: -20,
      },
      eyes: {
        x: -2,
        y: -21,
      },
      eyelids: {
        x: -2,
        y: -24,
      },
      mouth: {
        x: 1,
        y: 21,
      },
    },
    cookie: { // Lucky
      backEyes: {
        x: 3,
        y: -34,
      },
      eyes: {
        x: 3,
        y: -34,
      },
      eyelids: {
        x: 3,
        y: -33,
      },
      mouth: {
        x: 7,
        y: 7,
      },
    },
    nutmeg: { // Rosie
      backEyes: {
        x: 3,
        y: 9,
      },
      eyes: {
        x: 2,
        y: 9,
      },
      eyelids: {
        x: 1,
        y: 8,
      },
      mouth: {
        x: 2,
        y: 46,
      },
    },
    graham: { // Baxter
      backEyes: {
        x: 3,
        y: -28,
      },
      eyes: {
        x: 5,
        y: -34,
      },
      eyelids: {
        x: 5,
        y: -34,
      },
      mouth: {
        x: 4,
        y: 2,
      },
    },
    fancyGingy: {
      mugshot: {
        x: 78,
        y: 93,
        width: 395,
        height: 395,
      },
      backEyes: {
        x: 4,
        y: -16,
      },
      eyes: {
        x: 4,
        y: -17,
      },
      eyelids: {
        x: 5,
        y: -18,
      },
      mouth: {
        x: 5,
        y: 17,
      },
    },
    treasureHuntgingy: {
      backEyes: {
        x: 7,
        y: -22,
      },
      eyes: {
        x: 7,
        y: -22,
      },
      eyelids: {
        x: 7,
        y: -22,
      },
      mouth: {
        x: 8,
        y: 19,
      },
    },
    treasureHuntginger: {
      backEyes: {
        x: 2,
        y: -22,
      },
      eyes: {
        x: 2,
        y: -22,
      },
      eyelids: {
        x: 2,
        y: -22,
      },
      mouth: {
        x: 2,
        y: 24,
      },
    },
    treasureHuntchip: {
      backEyes: {
        x: 5,
        y: -22,
      },
      eyes: {
        x: 6,
        y: -21,
      },
      eyelids: {
        x: 5,
        y: -22,
      },
      mouth: {
        x: 8,
        y: 21,
      },
    },
    treasureHuntcookie: {
      backEyes: {
        x: 2,
        y: -40,
      },
      eyes: {
        x: 2,
        y: -40,
      },
      eyelids: {
        x: 2,
        y: -40,
      },
      mouth: {
        x: 7,
        y: -13,
      },
    },
    treasureHuntnutmeg: {
      backEyes: {
        x: 3,
        y: 9,
      },
      eyes: {
        x: 4,
        y: 9,
      },
      eyelids: {
        x: 3,
        y: 9,
      },
      mouth: {
        x: 3,
        y: 44,
      },
    },
    treasureHuntgraham: {
      backEyes: {
        x: 5,
        y: -36,
      },
      eyes: {
        x: 5,
        y: -34,
      },
      eyelids: {
        x: 5,
        y: -36,
      },
      mouth: {
        x: 6,
        y: 2,
      },
    },
    characterAssets: {
      gingy: { // Fluffy
        yBottom: 134,
      },
      ginger: { // Max
        yBottom: 78,
      },
      nutmeg: { // Rosie
        yBottom: 130,
      },
      cookie: { // Lucky
        yBottom: 136,
      },
      chip: { // Buttons
        yBottom: 130,
      },
      graham: { // Baxter
        backEyes: 'graham_eyes_back',
        eyes: 'graham_eyes',
        eyelids: 'graham_eyelids',
        yBottom: 166,
      },
      fancyGingy: {
        name: 'gingy', // Fluffy
        yBottom: 136,
      },
      treasureHuntgingy: {
        name: 'gingy',
        fullBody: 'treasureHunt_prelevelMascot0',
        backEyes: 'treasureHuntgingy_eyes_back',
        eyes: 'treasureHuntgingy_eyes',
        body: 'treasureHuntgingy_body',
        eyelids: 'treasureHuntgingy_eyelids',
        mouth_closed: 'treasureHuntgingy_mouth_closed',
        mouths: [
          'treasureHuntgingy_mouth_closed',
          'treasureHuntgingy_mouth_open',
          'treasureHuntgingy_mouth_surprised',
        ],
        yBottom: 135,
      },
      treasureHuntginger: {
        name: 'ginger',
        fullBody: 'treasureHunt_prelevelMascot1',
        backEyes: 'treasureHuntginger_eyes_back',
        eyes: 'treasureHuntginger_eyes',
        body: 'treasureHuntginger_body',
        eyelids: 'treasureHuntginger_eyelids',
        mouth_closed: 'treasureHuntginger_mouth_closed',
        mouths: [
          'treasureHuntginger_mouth_closed',
          'treasureHuntginger_mouth_open',
          'treasureHuntginger_mouth_surprised',
        ],
        yBottom: 75,
      },
      treasureHuntnutmeg: {
        name: 'nutmeg',
        fullBody: 'treasureHunt_prelevelMascot4',
        body: 'treasureHuntnutmeg_body',
        backEyes: 'treasureHuntnutmeg_eyes_back',
        eyes: 'treasureHuntnutmeg_eyes',
        eyelids: 'treasureHuntnutmeg_eyelids',
        mouth_closed: 'treasureHuntnutmeg_mouth_closed',
        mouths: [
          'treasureHuntnutmeg_mouth_closed',
          'treasureHuntnutmeg_mouth_open',
          'treasureHuntnutmeg_mouth_surprised',
        ],
        yBottom: 110,
      },
      treasureHuntcookie: {
        name: 'cookie',
        fullBody: 'treasureHunt_prelevelMascot3',
        body: 'treasureHuntcookie_body',
        backEyes: 'treasureHuntcookie_eyes_back',
        eyes: 'treasureHuntcookie_eyes',
        eyelids: 'treasureHuntcookie_eyelids',
        mouth_closed: 'treasureHuntcookie_mouth_closed',
        mouths: [
          'treasureHuntcookie_mouth_closed',
          'treasureHuntcookie_mouth_open',
          'treasureHuntcookie_mouth_surprised',
        ],
        yBottom: 175,
      },
      treasureHuntchip: {
        name: 'chip',
        fullBody: 'treasureHunt_prelevelMascot2',
        body: 'treasureHuntchip_body',
        backEyes: 'treasureHuntchip_eyes_back',
        eyes: 'treasureHuntchip_eyes',
        eyelids: 'treasureHuntchip_eyelids',
        mouth_closed: 'treasureHuntchip_mouth_closed',
        mouths: [
          'treasureHuntchip_mouth_closed',
          'treasureHuntchip_mouth_open',
          'treasureHuntchip_mouth_surprised',
        ],
        yBottom: 125,
      },
      treasureHuntgraham: {
        name: 'graham',
        fullBody: 'treasureHuntgraham_body',
        body: 'treasureHuntgraham_body',
        backEyes: 'treasureHuntgraham_eyes_back',
        eyes: 'treasureHuntgraham_eyes',
        eyelids: 'treasureHuntgraham_eyelids',
        mouth_closed: 'treasureHuntgraham_mouth_closed',
        mouths: [
          'treasureHuntgraham_mouth_closed',
          'treasureHuntgraham_mouth_open',
          'treasureHuntgraham_mouth_surprised',
        ],
        yBottom: 160,
      },
    },
    badges: { // Each key is the badge name. The data inside is the frame offset that is used with OMT_UI_AvatarWithFrameOffset
      /* eslint-disable object-curly-newline */
      default: { x: 0, y: 0, scale: 1.13, asset: 'avatar_frame_big' },
      leaderboardPlayer: { x: 0, y: 0, scale: 1, asset: 'lb2_avatar_user_box_empty' },
      leaderboardOther: { x: 0, y: 0, scale: 1, asset: 'lb2_avatar_main_box_empty' },
      treasureHuntGoldgingy: { x: 0, y: 2, scale: 1.4 },
      treasureHuntSilvergingy: { x: 0, y: 3, scale: 1.415 },
      treasureHuntBronzegingy: { x: 0, y: 3, scale: 1.415 },
      treasureHuntBasicgingy: { x: 0, y: 2, scale: 1.415 },
      treasureHuntGoldginger: { x: 0, y: 2, scale: 1.4 },
      treasureHuntSilverginger: { x: 0, y: 3, scale: 1.415 },
      treasureHuntBronzeginger: { x: 0, y: 3, scale: 1.415 },
      treasureHuntBasicginger: { x: 0, y: 2, scale: 1.415 },
      treasureHuntGoldchip: { x: 0, y: 2, scale: 1.4 },
      treasureHuntSilverchip: { x: 0, y: 3, scale: 1.415 },
      treasureHuntBronzechip: { x: 0, y: 3, scale: 1.415 },
      treasureHuntBasicchip: { x: 0, y: 2, scale: 1.415 },
      treasureHuntGoldnutmeg: { x: 0, y: 2, scale: 1.4 },
      treasureHuntSilvernutmeg: { x: 0, y: 3, scale: 1.415 },
      treasureHuntBronzenutmeg: { x: 0, y: 3, scale: 1.415 },
      treasureHuntBasicnutmeg: { x: 0, y: 2, scale: 1.415 },
      treasureHuntGoldcookie: { x: 0, y: 2, scale: 1.4 },
      treasureHuntSilvercookie: { x: 0, y: 3, scale: 1.415 },
      treasureHuntBronzecookie: { x: 0, y: 3, scale: 1.415 },
      treasureHuntBasiccookie: { x: 0, y: 2, scale: 1.415 },
      treasureHuntGoldgraham: { x: 0, y: 2, scale: 1.4 },
      treasureHuntSilvergraham: { x: 0, y: 3, scale: 1.415 },
      treasureHuntBronzegraham: { x: 0, y: 3, scale: 1.415 },
      treasureHuntBasicgraham: { x: 0, y: 2, scale: 1.415 },
      /* eslint-enable object-curly-newline */
    },
    buttonNineSlice: {
      layers: { // Default layers for buttons at regular size
        shadow: 'buttons/btn_shadow',
        base: 'buttons/btn_base',
        largeDetail: [],
        highlights: 'buttons/btn_highlight',
      },
      smallSlice: { // Default slice for small buttons
        left: 21,
        right: 21,
        top: 20,
        bottom: 25,
      },
      largeDetail: { // Default slice for large/detailed buttons
        left: 37,
        right: 32,
        top: 29,
        bottom: 26,
      },
    },
    buttonTintColours: { // Button nine-slice colour definitions
      green: 0x27fa00,
      blue: 0x3d9bff,
      red: 0xff0000,
      purple: 0xc73eff,
      orange: { // Provides its own layer
        shadow: 'buttons/btn_shadow',
        base: 'buttons/btn_orange',
        largeDetail: [],
      },
      gray: 0x888888,
      lightGreen: {
        shadow: 'buttons/btn_shadow',
        base: 'buttons/btn_lightGreen',
        largeDetail: [],
      },
    },
    chestPositioning: {
      inGame: {
        bottom: { x: 0, y: 0 },
        top: { x: -40, y: 0 },
        glow: { x: 0, y: -20 },
      },
      closed: {
        top: {
          x: 0,
          y: -47,
        },
      },
      opened: {
        bottom: {
          x: 0,
          y: 0,
        },
        top: {
          x: 37,
          y: -60,
        },
        glow: {
          x: 3,
          y: -42,
        },
      },
    },
    chestShuffle: {
      charSizeScale: 1.2,
    },
    checkedIconPast: {
      x: 35,
      y: 5,
    },
    checkedIcon: {
      x: 35,
      y: 5,
    },
    dailyMission: {
      ribbonText: {
        yPos: 45,
      },
    },
    giftUI: {
      sideGingy: {
        txtBg: {
          scale: {
            x: 1,
            y: 1,
          },
        },
        txt: {
          fontSize: '48px',
        },
      },
    },
    deconstructMsg: {
      tournamentTaunt: {
        aheadFriend: {
          x: -201,
          y: 162,
          angle: 0,
          avatar: {
            scale: 1.5,
            x: -2,
            y: -3,
            angle: -5,
          },
        },
        midFriend: {
          x: 10,
          y: 126,
          angle: 0,
          avatar: {
            scale: 1.25,
            x: -26,
            y: -15,
            angle: -22,
          },
        },
        lastFriend: {
          x: 216,
          y: 208,
          angle: 0,
          avatar: {
            scale: 1,
            x: -15,
            y: -21,
            angle: -19,
          },
        },
        text: {
          x: 0,
          y: -238,
          angle: 0,
        },
        trophy: { // Relative to aheadFriend
          x: -210,
          y: -58,
          angle: 10,
        },
        sparkles: [ // Relative to the trophy
          { x: 84, y: -76, angle: 0 },
          { x: -56, y: 25, angle: 0 },
          { x: -112, y: -35, angle: 0 },
          { x: 35, y: 54, angle: 0 },
          { x: -43, y: -61, angle: 0 },
          { x: 89, y: -7, angle: 0 },
        ],
      },
    },
    mockFacebookFriends: {
      friends: [
        { name: 'Gingy', image: 'friendshipGingy' },
        { name: 'Bubbles', image: 'friendshipBubbles' },
        { name: 'Finn', image: 'friendshipFinn' },
        { name: 'Dolly', image: 'friendshipDolly' },
        { name: 'Shelly', image: 'friendshipShelly' },
        { name: 'Spike', image: 'friendshipSpike' },
      ],
    },
    mapGift: {
      xCenterOffset: -265,
    },
    LossAversionWheelGroup: {
      useVillainTitles: true,
    },
    dailyReward: {
      title: {
        y: -235,
        style: 'DailyRewardTitle',
      },
      comeBackTxt: 'DailyRewardComeBack',
    },
    dailyChallengeIcon: {
      offsetY: 10,
      height: 125,
      width: 150,
    },
    dailyIcon: {
      width: 125,
      height: 90,
    },
    worldMapLvlButton: {
      closedMsg: {
        style: 'lvlButtonCloseMessage',
        x: 556,
        y: 200,
        width: 169,
        height: 120,
        rotation: -10,
      },
    },
    worldMap: {
      mapScale: 0.55,
      allowHScrolling: false,
      bubbleScale: 0.7,
      tiles: [
        'Map_path_tile3',
        'Map_path_tile0',
        'Map_path_tile1',
        'Map_path_tile2',
      ],
      tilePropCenter: {
        vertical: [
          [{ x: -145, y: 55, pool: 'left' }, { x: -300, y: -300, pool: 'leftFiller' }],
          [{ x: 145, y: 45, pool: 'right' }, { x: 350, y: -300, pool: 'rightFiller' }],
          [{ x: -145, y: 55, pool: 'behindRiver|left' }, { x: -150, y: 85, pool: 'aboveRiver' }, { x: -300, y: -300, pool: 'leftFiller' }],
          [{ x: 145, y: 75, pool: 'right' }, { x: 350, y: -300, pool: 'rightFiller' }],
        ],
        horizontal: [
          [{ x: -250, y: 95, pool: 'left' }, { x: -450, y: -300, pool: 'leftFiller' }],
          [{ x: 250, y: 85, pool: 'right' }, { x: 450, y: -300, pool: 'rightFiller' }],
          [{ x: -250, y: 55, pool: 'behindRiver|left' }, { x: -200, y: 105, pool: 'aboveRiver' }, { x: -450, y: -300, pool: 'leftFiller' }],
          [{ x: 250, y: 95, pool: 'right' }, { x: 450, y: -300, pool: 'rightFiller' }],
        ],
      },
      riverTileExtra: {
        index: 2, // The index on the tiles array
        levelNode: 1, // the index of the level node on that tile
        offset: [{ x: 378, y: 49 }, { x: 465, y: 85 }, { x: 471, y: 174 }, { x: 411, y: 246 }],
      },
      levelNodePositions: [ // for each tile, from the bottom
        [{ x: 326, y: 51 }, { x: 408, y: 90 }, { x: 462, y: 156 }, { x: 411, y: 225 }],
        [{ x: 334, y: 25 }, { x: 260, y: 85 }, { x: 251, y: 169 }, { x: 292, y: 252 }],
        [{ x: 378, y: 48 }, { x: 463, y: 94 }, { x: 471, y: 175 }, { x: 409, y: 246 }],
        [{ x: 331, y: 48 }, { x: 243, y: 88 }, { x: 198, y: 164 }, { x: 252, y: 240 }],
      ],
      mailboxPositions: [
        [{ x: 224, y: 233, scale: -1 }],
        [{ x: 477, y: 211, scale: 1 }],
        [{ x: 241, y: 279, scale: -1 }],
        [{ x: 450, y: 255, scale: 1 }],
      ],
      chestShufflePositions: [
        [{ x: 221, y: 226, scale: -1 }],
        [{ x: 474, y: 200, scale: 1 }],
        [{ x: 250, y: 260, scale: -1 }],
        [{ x: 448, y: 230, scale: 1 }],
      ],
      sagaMapChestPositions: [
        [{ x: 221, y: 188, scale: -1 }],
        [{ x: 475, y: 170, scale: 1 }],
        [{ x: 250, y: 220, scale: -1 }],
        [{ x: 446, y: 170, scale: 1 }],
      ],
      rewardPerTile: [
        'mailbox',
        'chestMap',
        'chestShuffle',
        'chestMap',
        '',
      ],
      riverTint: [
        0xb4ffde,
        0xffe2fd,
        0xc2f1ff,
        0xffef91,
        0xebcbff,
      ],
      grassColour: 0x8dd415,
    },
  worldMapButtonOrder: {
      vertical: {
        left: ['tournament', 'dailyChallenge', 'mapGift', 'tokenEvent', 'specialShopDeal'],
        right: ['dailyIcon', 'friendshipChest', 'treasurehunt', 'xPromo'],
        alignXDynamically: true,
      },
      horizontal: {
        left: ['xPromo'],
        right: ['dailyIcon', 'friendshipChest', 'tournament', 'dailyChallenge', 'mapGift', 'tokenEvent', 'specialShopDeal', 'treasurehunt'],
        alignXDynamically: true,
      },
    },

    // config overrides for wheels / wheel items
    wheelConfigs: {
      dailyPrizeWheel: {
        spinner: { wheelSegments: 24 }, // amount of pegs
        itemConfigOverrides: {
          COINS: {
            text: { style: { fontSize: 33 }, offset: { y: 4 } },
            icon: { scale: 0.65 },
          },
          COINS_SPECIAL: {
            text: { style: { fontSize: 29 }, offset: { y: 2 } },
            icon: { scale: 0.65 },
          },
          BOOSTER: {
            text: { style: { fontSize: 33 }, offset: { y: 4 } },
          },
        },
      },
      lossAversionPrizeWheel: {
        spinner: { wheelSegments: 24 }, // amount of pegs
        itemConfigOverrides: {
          COINS: {
            text: { style: { fontSize: 40 } },
          },
        },
      },
      requestHelpPrizeWheel: {
        spinner: { wheelSegments: 24 }, // amount of pegs
        itemConfigOverrides: {
          COINS: {
            text: { style: { fontSize: 40 } },
          },
        },
      },
      realMoneyPrizeWheel: {
        itemConfigOverrides: {
          COINS: {
            text: {
              style: 'realMoneyWheel-coinTextGold',
              offset: { x: 125, y: 0 },
            },
            icon: {
              scale: 0.5,
              offset: { x: 145, y: 0 },
            },
          },

          COINS_SPECIAL: {
            text: {
              style: 'realMoneyWheel-coinTextGoldSpecial',
              offset: { x: 125, y: 0 },
            },
            icon: {
              scale: 0.5,
              offset: { x: 145, y: 0 },
            },
          },

          COINS_PLAT: {
            text: {
              style: 'realMoneyWheel-coinTextPlat',
              offset: { x: 145, y: 0 },
            },
            icon: {
              scale: 0.5,
              offset: { x: 165, y: 0 },
            },
          },

          COINS_SPECIAL_PLAT: {
            text: {
              style: 'realMoneyWheel-coinTextSpecialPlat',
              offset: { x: 145, y: 0 },
            },
            icon: {
              scale: 0.5,
              offset: { x: 165, y: 0 },
            },
          },
        },
      },
    },

    Window_FortuneCookie: {
      categories: {
        funny: {
          index: 1,
          enabled: true,
        },
        prediction: {
          index: 3,
          enabled: true,
        },
        love: {
          index: 2,
          enabled: true,
        },
        wisdom: {
          index: 4,
          enabled: true,
        },
        game: {
          index: 0,
          enabled: false,
        },
      },
      elementLayouts: {
        bannerTextOffset: { x: 12, y: -10 },
        yPos: { // range of y-positions (for responsiveness)
          shareBannerGroup: { min: -375, max: -460 },
          msgGroup: { min: -212, max: -242 },
          msgImgGroup: { min: 60, max: 80 },
          shareBtn: { min: 395, max: 460 },
        },
        scaling: { // range of scale factors (for responsiveness)
          msgGroup: { min: 0.84, max: 1 },
          msgImgGroup: { min: 1.05, max: 1.22 },
        },
      },
      avatarLayout: {
        funny: {
          x: -81,
          y: -89,
          width: 130,
          height: 130,
          angle: 3,
        },
        prediction: {
          x: 0,
          y: -60,
          width: 112,
          height: 112,
          angle: 2,
        },
        love: {
          x: -84,
          y: -82,
          width: 130,
          height: 130,
          angle: 2,
        },
        wisdom: {
          x: -84,
          y: -77,
          width: 125,
          height: 125,
          angle: 3,
        },
        game: { // unused
          x: 38,
          y: -88,
          width: 110,
          height: 110,
          angle: 15,
        },
      },
      tagSymbolOnly: false,
      tagPosition: {
        x: -50,
        y: 38,
      },
    },
    MsgFortuneCookie: {
      avatarLayout: {
        funny: {
          x: 496,
          y: 113,
          width: 138,
          height: 138,
          angle: 5.62,
        },
        prediction: {
          x: 496,
          y: 113,
          width: 138,
          height: 138,
          angle: 5.62,
        },
        love: {
          x: 496,
          y: 113,
          width: 138,
          height: 138,
          angle: 5.62,
        },
        wisdom: {
          x: 496,
          y: 113,
          width: 138,
          height: 138,
          angle: 5.62,
        },
        game: {
          x: 496,
          y: 113,
          width: 138,
          height: 138,
          angle: 5.62,
        },
      },
    },
    CandyType_FortuneCookie: {
      timerPosition: {
        x: 24,
        y: 11,
      },
    },
    UI_MapPanel: {
      starData: {
        vertical: {
          xPos: -130,
        },
      },
      coinData: {
        vertical: {
          position: {
            x: 96,
            y: 37,
          },
          text: {
            y: 2, // Relative to center of container
          },
        },
      },
      settingsMenu: {
        vertical: {
          x: 265,
          y: 35,
        },
      },
    },
    Window_mysteryGift: {
      titleOffsetY: 0,
    },
    Window_friendOvertaken: {
      titleTxt: {
        style: 'friendOvertaken',
      },
    },
    Window_shop2: {
      headerFontStyle: 'shop2-Header',
      isShowing3hGift: true,
      topBarTextOffset: -12,
      useTileEntryBorder: true,
      scrollHeightOffset: -30,
    },
    Window_shop3: {
      useBoldSchema: true,
      maxSpecialSlots: 6,
      regularDealFrameSlice: { // Slices for the frame
        top: 37,
        bottom: 121,
        right: 60,
        left: 75,
      },
      headerSlice: { // Nineslice for header pieces
        top: 19,
        left: 8,
        bottom: 19,
        right: 8,
      },
      specialDealFrameExtra: {
        offsetX: 0,
        offsetY: 0,
        topOfFrame: 45,
        bottomOfFrame: 158,
      },
      specialDealFrameSlice: { // The slices for the special deal frames
        top: 45,
        bottom: 158,
        left: 68,
        right: 201,
      },
      specialDealRibbonSize: { // Size of ribbion
        height: 60,
      },
      specialDealRibbonSlice: { // The slices for the ribbon
        top: 30,
        bottom: 30,
        left: 58,
        right: 58,
      },
      specialDealBoosterBoxSlice: { // The slices for the booster box details
        top: 40,
        bottom: 35,
        left: 43,
        right: 49,
      },
      tagBaseMultipler: 1,
      regularDealTagIndex: 1,
      specialDealTintData: [ // Tint data on the layout
        {
          boosterBox: {
            asset: 'shop3_specialDealBoosterBoxFTU',
            coinBar: {
              tint: 0xFF2900,
              textStyle: 'shop3-boosterTextStyle0',
            },
          },
          valueTagTint: 2,
        },
        {
          boosterBox: {
            asset: 'shop3_specialDealBoosterBox1',
            coinBar: {
              tint: 0x259FFF,
              textStyle: 'shop3-boosterTextStyle1',
            },
          },
          valueTagTint: 1,
        },
      ],
    },
    Window_highscoreBeaten: {
      titleTxt: {
        style: 'highscoreBeaten',
      },
    },
    Window_crossPromo: {
      titleTxt: {
        style: 'XPromoTitle',
      },
    },
    Window_giveUp: {
      levelTxt: {
        style: 'giveUpLevelTxt',
      },
    },
    Window_botOptIn: {
      titleTxt: {
        style: 'BotOptInTitle',
      },
    },
    Window_Brag: {
      closeButton: { offsetX: 0, offsetY: 0 },
      bannerImage: { fullscreen: 'pink_banner' },
      content: {
        friendsLayout: { // double avatar layout
          fullscreen: { x: 0, y: 0, minWidth: 560, maxWidth: 560 },
          friendAvatar: {
            avatarSize: 146,
            x: 118,
            y: 59,
            angle: 11,
          },
          playerAvatar: {
            avatarSize: 138,
            x: -127,
            y: -55,
            angle: -8,
          },
        },
        soloLayout: { // single avatar layout
          fullscreen: { x: 0, y: 25, minWidth: 640, maxWidth: 670 },
          playerAvatar: {
            avatarSize: 135,
            x: -10,
            y: 36,
            angle: -8,
          },
        },
        skipTutorialLayout: { // for first time users winning a challenge
          fullscreen: { x: 0, y: 50, minWidth: 0, maxWidth: 650 },
          imageScale: 0.65,
          playerAvatar: {
            avatarSize: 100,
            x: -100,
            y: -50,
            angle: 0,
          },
        },
      },
    },
    Window_notEnoughLives: {
      livesNrTxt: {
        x: 10,
      },
      coinsTxt: {
        y: -286,
        style: 'NotEnoughLivesCoins',
      },
    },
    Window_ItemShop: {
      titleTextStyle: {
        style: 'font-white',
        fontSize: '60px',
        align: 'center',
      },
    },
    Window_taskSlider: {
      taskTxt: {
        horizontalY: 30,
        style: {
          style: 'taskText',
        },
      },
    },
    Window_newsHomeScreen: {
      button: {
        shouldPulse: true,
        x: 0,
        y: 215,
      },
      continueBtn: {
        x: 0,
        y: 295,
      },
      continueBtnTxt: {
        x: 0,
        y: 295,
      },
    },
    Window_popupOffer: {
      vertical: {
        deal: {
          assetsKeys: {
            moneyOnly: 'shop3_specialDeal2',
            fewBoosters: 'shop3_specialDeal1',
            manyBoosters: 'shop3_specialDeal0',
          },
        },
        playerCoinbar: {
          offsetY: -240,
        },
        dealCoinbar: {
          scale: 1.2,
          fontSize: 36,
          tint: 0xFF4210,
        },
        multiplier: {
          offsetY: 12,
          offsetX: -17,
          scale: 1,
          bgScale: 1.1,
          txt: { offsetX: 0, offsetY: 0 },
        },
        bg: {
          height: 550,
          outerSlices: {
            left: 145, right: 149, top: 221, bottom: 139,
          },
          innerSlices: {
            left: 72, right: 72, top: 66, bottom: 66,
          },
          innerOffsetY: -12,
          innerTint: 0xffb20d,
        },
        header: {
          offsetY: -2,
          ribbonOffsetY: 5,
          textOffsetY: 2,
          ribbonConfig: {
            asset: 'shop3_dealRibbon0',
          },
        },
        exitConfirm: {
          mascot: { offsetX: 45, offsetY: 62, scaleX: 0.75, scaleY: 0.75 },
          bubble: { offsetX: 15, offsetY: -340 },
        },
        buyButton: { offsetY: -1 },
      },
      horizontal: {
        deal: {
          assetsKeys: {
            moneyOnly: 'shop3_specialDeal2',
            fewBoosters: 'shop3_specialDeal1',
            manyBoosters: 'shop3_specialDeal0',
          },
        },
        playerCoinbar: {
          offsetY: -260,
        },
        dealCoinbar: {
          scale: 1.2,
          fontSize: 36,
          tint: 0xFF4210,
        },
        multiplier: {
          offsetY: 12,
          offsetX: -812,
          scale: 1,
          bgScale: 1.1,
          txt: { offsetX: 0, offsetY: 0 },
        },
        bg: {
          height: 550,
          outerSlices: {
            left: 145, right: 149, top: 221, bottom: 139,
          },
          innerSlices: {
            left: 72, right: 72, top: 66, bottom: 66,
          },
          innerOffsetX: -240,
          innerOffsetY: 23,
          innerTint: 0xffb20d,
        },
        header: {
          offsetY: -2,
          ribbonOffsetY: 5,
          textOffsetY: 2,
          ribbonConfig: {
            asset: 'shop3_dealRibbon0',
          },
        },
        exitConfirm: {
          mascot: { offsetX: 1045, offsetY: 10, scaleX: -0.65, scaleY: 0.65 },
          bubble: { offsetX: 563, offsetY: -180 },
        },
        buyButton: { offsetY: -1 },
      },
    },

    Window_noAdsPopup: {
      vertical: {
        window: {
          x: 0,
          y: 0,
        },
        title: {
          x: 0,
          y: -284,
          text: 'Did you know?',
          style: 'noAdsPopup-title',
          maxWidth: 340,
        },
        background: {
          width: 560,
          height: 650,
        },
        dealChest: {
          x: 110,
          y: 170,
          scale: 0.9,
        },
        gingy: {
          x: -130,
          y: 187,
          scale: 0.8,
        },
        adCrossed: {
          x: 0,
          y: -5,
          scale: 0.475,
        },
        message: {
          x: 0,
          y: -230,
          maxWidth: 448,
          maxHeight: 165,
          text: 'You can remove forced ads forever by making any purchase in the coins store',
          style: {
            style: 'noAdsPopup-message',
            fontSize: 36,
          },
        },
        continueButton: {
          x: 0,
          y: 320,
          width: 230,
          height: 90,
          text: 'Continue',
          style: {
            style: 'font-white',
            fontSize: 64,
          },
          pulse: 1.05,
        },
      },

      horizontal: {
        window: {
          x: 0,
          y: 100,
        },
        title: {
          x: 0,
          y: -355,
          text: 'Did you know?',
          style: 'noAdsPopup-title',
          maxWidth: 500,
        },
        background: {
          width: 1300,
          height: 800,
        },
        dealChest: {
          x: 380,
          y: 160,
          scale: 1.55,
        },
        gingy: {
          x: -390,
          y: 178,
          scale: 1.4,
        },
        adCrossed: {
          x: 0,
          y: 25,
          scale: 0.95,
        },
        message: {
          x: 0,
          y: -290,
          maxWidth: 1000,
          maxHeight: 200,
          text: 'You can remove forced ads forever by making any purchase in the coins store',
          style: {
            style: 'noAdsPopup-message',
            fontSize: 64,
          },
        },
        continueButton: {
          x: 0,
          y: 300,
          width: 275,
          height: 130,
          text: 'Continue',
          style: {
            style: 'font-white',
            fontSize: 72,
          },
          pulse: 1.05,
        },
      },
    },

    RealMoneyWheel: {
      gingy: {
        x: 0,
        y: 270,
        bobbingAnim: true,
        bobbingAnimConfig: {
          vDisplacement: 10,
          hDisplacement: 0,
          cycleLength: 7500, // ms
        },
      },
    },
    UI_Life: {
      livesNrTxt: {
        vertical: {
          x: 5,
        },
        horizontal: {
          x: 5,
        },
      },
      timerTxt: {
        vertical: {
          y: 0,
        },
        horizontal: {
          y: 0,
        },
      },
      unlimitedTimerTxt: {
        vertical: {
          y: 0,
        },
        horizontal: {
          y: 0,
        },
      },
      timerMaxTxt: {
        vertical: {
          y: 0,
        },
        horizontal: {
          y: 0,
        },
      },
    },
    UI_PointsCounter: {
      text: {
        style: 'UIPointsTxt',
      },
    },
    UI_ProgressBarHorizontal: {
      scale: 1,
      offset: {
        x: 0,
        y: 3,
      },
    },
    gifts: {
      shineEnabled: false,
      // shineOffsetX: -17,
      // shineOffsetY: -50,
    },
    // Super hard update element config
    superhard: {
      window_level: {
        hard_popup: {
          top: 477,
          bottom: 135,
          left: 262,
          right: 264,
        },
        super_hard_popup: {
          top: 285,
          bottom: 315,
          left: 260,
          right: 263,
        },
        hard_tint: 0xEBB5FF,
        super_hard_tint: 0xFFBEBF,
      },
      speech_bubble: {
        hard_bubble: {
          top: 20,
          bottom: 15,
          left: 58,
          right: 55,
        },
        super_hard_bubble: {
          top: 54,
          bottom: 55,
          left: 107,
          right: 75,
        },
        gingy_bubble: {
          top: 45,
          bottom: 35,
          left: 112,
          right: 112,
        },
      },
      gingyBubble: {
        offsetX: 0.01,
      },
      window_levelFailed: {
        levelTxtStyle: {
          style: 'font-white',
          fontSize: '60px',
        },
      },
      bubbleTipPos: {
        hard: {
          'top-right': {
            x: 400,
            y: -10,
          },
          'top-left': {
            x: 220,
            y: -10,
          },
          right: {
            x: 505,
            y: 170,
          },
          left: {
            x: -35,
            y: 160,
          },
        }, 
        superhard: {
          'top-right': {
            x: 400,
            y: -28,
          },
          'top-left': {
            x: 220,
            y: -28,
          },
          right: {
            x: 515,
            y: 160,
          },
          left: {
            x: -45,
            y: 160,
          },
        }, 
      },
      villain_speech: {
        hard_win: 'This is lame, smell you later!',
        super_hard_win: 'This isn\'t over! We\'ll be back!',
        hard_oom: "What's wrong? Giving up already?",
        super_hard_oom: "Is that all ya got? We expected a bit more!",
        hard_lose: 'That was too easy! Try harder next time, haha!',
        super_hard_lose: 'Haha! You weren\'t even close to beating us!',
        hard_mystery_gift: 'Look at everything you are about to lose!',
        super_hard_mystery_gift: 'We\'ll be taking them boosters from ya now!',
      },
      tutorialSpeech: {
        hard: {
          pre_win_saga_map: [
            {
              source: 'gingy',
              text: "Watch out! It's that stinky %mainVillain%!",
              x: 50,
              y: 80,
              clickable: true,
            },
            {
              source: 'villain',
              index: 1,
              subIndex: 1,
              text: 'This theme park could use some spray... paint.',
              x: 50,
              y: 20,
              pos: 'top-left',
            },
          ],
          level_window: [
            {
              source: 'villain',
              index: 1,
              subIndex: 4,
              text: 'This theme park is going down!',
              x: 50,
              y: 20,
              pos: 'left',
              duration: 2000,
            },
            {
              source: 'gingy',
              text: 'You can use additional boosters on hard levels!',
              x: 50,
              y: 80,
            },
          ],
          post_corruption_level_window: [
            {
              source: 'villain',
              index: 1,
              subIndex: 4,
              text: "Catch a whiff of this!|Give up while you can!|You've got no chance!",
              x: 50,
              y: 20,
              pos: 'left',
            },
          ],
        },
        super_hard: {
          pre_win_saga_map: [
            {
              source: 'gingy',
              text: "It's  %mainVillain%! And he brought company!",
              x: 50,
              y: 80,
              clickable: true,
            },
            {
              source: 'villain',
              index: 1,
              subIndex: 1,
              text: 'What do you think of this place, %sideVillain%?',
              x: 50,
              y: 20,
              pos: 'top-left',
              clickable: true,
            },
            {
              source: 'villain',
              index: 2,
              subIndex: 4,
              text: 'This place is a dump, let\'s tear it down!',
              x: 50,
              y: 20,
              pos: 'top-left',
            },
          ],
          level_window: [
            {
              source: 'villain',
              index: [1, 2],
              subIndex: [4, 4],
              text: 'You can\'t foil our plans!',
              x: 50,
              y: 20,
              pos: 'double',
              duration: 2000,
            },
            {
              source: 'gingy',
              text: 'Using extra boosters will help us defeat them!',
              x: 50,
              y: 80,
            },
          ],
          post_corruption_level_window: [
            {
              source: 'villain',
              index: [1, 2],
              subIndex: [4, 4],
              text: 'Try to give us a challenge!|You can\'t stop us!|We\'re bringing this theme park down!',
              x: 50,
              y: 20,
              pos: 'double',
            },
          ],
        },
      },
    },
  },
};
